import React from "react"
import styles from "./styles.module.scss"

interface Props {
  page: number
}
/**
 * Step4見積結果画面の見積もり金額の追従ヘッダー
 * @param {number} page - 画面で表示しているプラン
 */
const Pagination = ({ page }: Props) => {
  return (
    <div className={styles.root}>
      <div className={`${styles.root__dot} ${page === -1 ? styles.root__on : ""}`} />
      <div className={`${styles.root__dot} ${page === 0 ? styles.root__on : ""}`} />
      <div className={`${styles.root__dot} ${page === 1 ? styles.root__on : ""}`} />
    </div>
  )
}

export default Pagination
